module.exports = __webpack_public_path__ + "static/Ultra_Gaane-c753bda751ba4fa1e934282ab69ac8e5.png";